import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Slide,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface PopupProps {
  onClose: () => void;
  isOpen: boolean;
}

const CompanyUnlockWarningPopup: React.FC<PopupProps> = ({
  onClose,
  isOpen,
}) => {
  const [countdown, setCountdown] = React.useState(5);
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    timerRef.current = setTimeout(() => {
      onClose();
    }, 5000);

    return () => {
      clearInterval(intervalRef.current!);
      clearTimeout(timerRef.current!);
    };
  }, [onClose]);

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-handle-confirm"
      PaperProps={{
        sx: {
          width: {
            xs: '370px',
            sm: '370px',
            md: '499px',
            lg: '820px',
            xl: '820px',
          },
          maxWidth: '627px !important',
          backgroundImage: 'url("/static/companyUnlock/frame_bg_img.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'auto',
          }}
        >
          <Box>
            <img
              src="/static/companyUnlock/warning.gif"
              alt="investor"
              style={{
                width: '120px',
                height: '120px',
                padding: '-10px',
                margin: '-10px',
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 700,
                color: '#5A0ED4',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                animation: 'moveText 3s linear infinite',
                textAlign: 'center',
              }}
            >
              Multiple Time Clicked
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Hello there! 👋
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Just a heads up: We've noticed you've made multiple requests to
              unlock data. We wanted to let you know that your initial request
              is already being processed!
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Our team is working hard to fulfill your request as swiftly as
              possible. Submitting additional requests may lead to a delay in
              processing.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              We appreciate your patience and understanding. We'll notify you the moment your data is ready for access.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '10px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#767676',
                textAlign: 'center',
              }}
            >
              Thank you for your cooperation!
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginY: '16px',
              marginX: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: { md: '16px', xs: '12px' },
                fontFamily: 'Oxygen',
                fontWeight: 400,
                color: '#FF0000',
                textAlign: 'center',
              }}
            >
              Closing in {countdown} seconds...
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyUnlockWarningPopup;
